
import PictureListSing from '@/components/PictureList/PictureListSing'
export default {
  components: { PictureListSing },
  data(){

    return{
      qualificationForm:{
        companyName:'',
        qualifications:[]
      },
      companyList:[],
      url:{
        get: SZH.assets.api + '/Custom/GetSelectCompanyForCustom',
        GetCompanyInfoNew:SZH.assets.api + '/Custom/GetCustomQualifications',
        UploadCompanyAuthInfo:SZH.assets.api + '/Custom/UploadCompanyAuthInfo',
        SingleUpoladCustomQualification:SZH.assets.api + '/Custom/SingleUpoladCustomQualification',
      },
      fullscreenLoading:false,
      limitNum:1,
      picType:'companyQualifications',
      picId:'',
      bigForm:{},
      isCom:'',
      companyId:''
    }
  },
  methods:{
    goBack(){
      this.$router.go(-1);
    },
    imgUrl(item){
      let img = '';
      if (item.Picture && item.Picture.length > 0) {
        img = SZH.assets.image + item.Picture[0].Url;
      } else {
        img = '';
      }
      return img
    },
    onInput(dd){
      console.log(dd);
    },
    ToSubmit(){
      let self = this;
      //第一步，只提交日期和图片都传了的数据
      let canSubmitQualifications = self.qualificationForm.qualifications.filter(item=>item.ExpirationTime && item.Picture && item.Picture.length>0);
      canSubmitQualifications.forEach(item=>{
        item.Picture = item.Picture[0];
      });
      self.bigForm.BindQualifications = canSubmitQualifications;

      self.fullscreenLoading = true;
      self.$http.post(self.url.UploadCompanyAuthInfo, {
        Data:self.bigForm
      }).then(result => {
        if (result.state == 1) {
          self.$message.success('提交成功');
          self.$router.push({
            path:'/My/companyFinished',
          });
        } else {
          self.$message.error(result.message);
        }
        self.fullscreenLoading = false;
      }, () => {
        self.fullscreenLoading = false;
      });
    },
    getCompanyList(){
      let self = this;
      self.$http.post(self.url.get, {}).then(result => {
        if (result.state == true && result.data && result.data.length>0) {
          self.companyList = result.data;
        } else {
          self.companyList = [];
        }
      }, () => {
      });
    },
    GetCompanyInfoNewFun(v) {
      var self = this;
      self.fullscreenLoading = true;
      self.$http.post(self.url.GetCompanyInfoNew, {
        Id:v,
        CustomType:self.isCom?1:0
      }).then(result => {
        if (result.state == true && result.data != null) {
          // 接口返回的是
          result.data.forEach(item=>{
            if(item.Picture){
              item.Picture = [item.Picture]
            }else{
              item.Picture = [];
            }
          });
          self.qualificationForm.qualifications = result.data;
        } else {
          self.qualificationForm.qualifications = []
        }
        self.fullscreenLoading = false;
      }, () => {
        self.fullscreenLoading = false;
      });
    },
    singSubmit(item){
      let self = this;
      let obj = {};
      if(self.companyId){
        item.CustomId = self.companyId;
        item.CustomType = 1;
      }else{
        item.CustomId = '';
        item.CustomType = 0;
      }
      if(item.ExpirationTime && item.Picture){
        for(let i in item){
          if(item.Picture){
            obj.Picture = item.Picture[0];
          }
          obj[i] = item[i];
        }
        self.fullscreenLoading = true;
        self.$http.post(self.url.SingleUpoladCustomQualification, obj).then(result => {
          if (result.state == true) {
            self.$message.success('提交成功');
            self.$router.push({
              path:'/My/myMember',
            });
          } else {
            self.$message.error(result.message);
          }
          self.fullscreenLoading = false;
        }, () => {
          self.fullscreenLoading = false;
        });
      }else{
        self.$.message.error('请选择到期时间和资质图片！')
      }
    },
  },
  created(){
  },
  mounted() {
    this.isCom = this.$route.query.iscom;
    this.companyId = ''
    if(this.isCom){
      this.getCompanyList();
    }else{
      this.GetCompanyInfoNewFun('');
    }
    // this.qualificationForm.companyName = this.bigForm.Name;
    //

    // if(this.bigForm.Come){
    //   this.comeFrom = this.bigForm.Come;
    // }else{
    //   this.comeFrom = '';
    // }

  },
  watch: {

  }
}



// WEBPACK FOOTER //
// ./src/views/Me/CompanyQualificationsInfo/CompanyQualificationsInfo.js